<template>
  <div id="ps-event-apply">
    <h1 class="title-md">申請成為 INSTO Tap 賣家，為您帶來更多生意！</h1>
    <h2 class="title-sm">
      申請只要5分鐘、線上申請更方便
    </h2>
    <div class="apply-steps-wrapper">
      <div class="step-wrapper">
        <div class="step-img bg-contain step01"></div>
        <div class="step-title">下載 App</div>
      </div>
      <div class="step-wrapper">
          <div class="step-img bg-contain step02"></div>
          <div class="step-title">填寫資料</div>
      </div>
        <div class="step-wrapper">
        <div class="step-img bg-contain step03"></div>
        <div class="step-title">送出審核</div>
      </div>
        <div class="step-wrapper">
        <div class="step-img bg-contain step04"></div>
        <div class="step-title">審核成功</div>
      </div>
    </div>
    <div class="action-button-wrapper">
      <a href="https://tap.ins.to/products/apply-example-personal" target="_blank" id="ps-click-apply-exurl">
        <button class="action-button">
          申請個人賣家範例
        </button>
      </a>
      <a href="https://merchant.ins.to/insto-apply/signup/" target="_blank" id="ps-click-apply-web">
        <button class="action-button">
          立即線上申請
        </button>
      </a>
    </div>
    <button class="action-button" v-on:click="download()" id="ps-click-apply-acbtn">
      下載體驗快速收款
    </button>
    <p>審核時間最少需 7 個⼯作天（不含例假⽇、國定假⽇）</p>
  </div>
</template>

<script>
export default {
    methods: {
      download() {
      const modal = document.getElementById('ps-event-modal')
      modal.classList.add('show')
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "@/assets/sass/main.scss";
  @import "@/assets/sass/personal-slashie.scss";

#ps-event-apply {
  padding: 80px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 1552px) {
    padding: 60px 100px;
  }
  @media screen and (max-width: 1024px) {
    padding: 50px;
  }
  @media screen and (max-width: 768px) {
    padding: 40px 20px;
  }
  .apply-steps-wrapper { 
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    @media screen and (max-width: 1024px) {
      width: 800px;
    }
    @media screen and (max-width: 768px) {
      width: 400px;
    }
    @media screen and (max-width: 3px) {
      width: 100%;
    }
    
    .step-wrapper {
       display: flex;
       flex-direction: column;
       justify-content: center;
       align-items: center;
       .step-img {
        height: 150px;
        width: 150px;
        margin: 0 10px;
        background-color: white;
       }
       .step-title {
        margin-top: 12px;
        font-size: 18px;
       }
    }
  }
  p {
    font-size: 15px;
    margin-top: 40px;
    text-align: left;
    max-width: 800px;
  }
}

.step01 {
  background-image: url('../../assets/imgs/event/foreign-card/fc-apply-step01.png');
}

.step02 {
  background-image: url('../../assets/imgs/event/foreign-card/fc-apply-step02.png');
}

.step03 {
  background-image: url('../../assets/imgs/event/foreign-card/fc-apply-step03.png');
}

.step04 {
  background-image: url('../../assets/imgs/event/foreign-card/fc-apply-step04.png');
}

#ps-click-apply-acbtn {
  margin-top: 20px;
  @media screen and (max-width: 768px) {
    margin-top: 8px;
    }
}

</style>
